module.exports = __webpack_public_path__ + "static/TangleTower3-b33e0d9cd3944d4e647a8c8fabf5c76b.webp";